import { Helmet } from "react-helmet-async";

const SITE = "https://blog.logcomex.ai";
const NAME = "Blog Logcomex.ai";

type Props = {
  path: string;
  title: string;
  description: string;
  image?: string;
  /** Use quando a rota é duplicata de outra (ex.: /blog → /). */
  canonicalPath?: string;
};

export function PageSEO({ path, title, description, image, canonicalPath }: Props) {
  const url = `${SITE}${path}`;
  const canonical = `${SITE}${canonicalPath ?? path}`;
  const fullTitle = `${title} | ${NAME}`;
  const img = image || `${SITE}/og/home.png`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={NAME} />
      <meta property="og:locale" content="pt_BR" />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={img} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}

export default PageSEO;
